import { LogoNameType, LogoSizeType } from "@/lib/main";

const getLogoWidth = (name: LogoNameType, size: LogoSizeType) => {
  let width = "6.25rem";

  if (
    name === "blue-on-white" ||
    name === "blue-on-white-ar" ||
    name === "white-on-blue" ||
    name === "white-on-blue-ar"
  ) {
    width = (() => {
      switch (size) {
        case "sm":
          return "6.25rem";
        case "md":
          return "7.5rem";
        default:
          return "6.25rem";
      }
    })();
  }

  if (name === "blue" || name === "white") {
    width = (() => {
      switch (size) {
        case "sm":
          return "6.5833rem";
        case "md":
          return "8rem";
        default:
          return "11.52rem";
      }
    })();
  }

  if (name === "blue-ar" || name === "white-ar") {
    width = (() => {
      switch (size) {
        case "sm":
          return "2.625rem";
        case "md":
          return "3.3125rem";
        default:
          return "2.625rem";
      }
    })();
  }

  return width;
};

export default getLogoWidth;
